interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  change: 'up' | 'down' | 'same' | 'hot';
}

const rankItems: RankItem[] = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子事件', tag: '恋情', heat: '982万', change: 'hot' },
  { rank: 2, title: '知名女星工作室起诉造谣者进展', tag: '法律', heat: '876万', change: 'up' },
  { rank: 3, title: '热门综艺录制现场嘉宾翻脸冲突', tag: '综艺', heat: '754万', change: 'up' },
  { rank: 4, title: '头部带货主播因虚假宣传被全面解约', tag: '带货', heat: '689万', change: 'down' },
  { rank: 5, title: '韩娱经纪公司被曝系统性压榨练习生', tag: '韩娱', heat: '598万', change: 'same' },
  { rank: 6, title: '多位歌手宣布取消下半年巡回演唱会', tag: '音乐', heat: '534万', change: 'up' },
];

const SectionRanking = () => (
  <section id="ranking" className="py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热度榜单</h2>
        <p className="mt-2 text-sm text-foreground-500">每日更新，吃瓜热度一目了然</p>
      </div>
      <div className="max-w-[800px] mx-auto">
        <div className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden">
          {rankItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-5 py-4 border-b border-background-200/50 last:border-b-0 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <span className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-primary-300 text-background-50' :
                'bg-secondary-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-900 truncate">{item.title}</p>
              </div>
              <span className="flex-shrink-0 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs">{item.tag}</span>
              <div className="flex-shrink-0 flex items-center gap-1.5">
                <span className="text-xs text-foreground-400">{item.heat}</span>
                {item.change === 'up' && <i className="ri-arrow-up-line text-primary-500 text-xs"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-accent-500 text-xs"></i>}
                {item.change === 'same' && <i className="ri-subtract-line text-foreground-300 text-xs"></i>}
                {item.change === 'hot' && <i className="ri-fire-fill text-primary-500 text-xs"></i>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default SectionRanking;